import { render, staticRenderFns } from "./layout-product-description.vue?vue&type=template&id=6fc6d078"
import script from "./layout-product-description.vue?vue&type=script&lang=js"
export * from "./layout-product-description.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports